import { API_URL, getCachedSessionId } from 'src/services/common';
import { UpdateProjectResponseData } from './interface/updateProjectResponseData';
import { api } from '../../../../util/axios-instance';
import { Project } from '../interfaces/fetchProjects.interface';

export const updateProject = async (
  projectId: string,
  project: Project
): Promise<UpdateProjectResponseData | undefined> => {
  const response = await api.put<UpdateProjectResponseData>(
    `${API_URL}/v1/project/${projectId}/updateProject`,
    project,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
